import { ref, computed } from 'vue'

const cache = ref({})
const isLoading = ref(false)
const error = ref(null)
const currentReportId = ref(null)

async function fetchMarkdown(reportId) {
  if (!reportId) return null

  const cached = cache.value[reportId]
  if (cached && (Date.now() - cached.fetchedAt) < 5 * 60 * 1000) {
    currentReportId.value = reportId
    error.value = null
    return cached
  }

  isLoading.value = true
  error.value = null
  currentReportId.value = reportId

  try {
    const res = await fetch(`/api/reports/markdown?reportId=${encodeURIComponent(reportId)}`)
    const data = await res.json()

    if (data.success && data.markdown) {
      const entry = {
        content: data.markdown.content,
        title: data.markdown.title || reportId,
        source: data.markdown.source || 'unknown',
        fetchedAt: Date.now(),
      }
      cache.value = { ...cache.value, [reportId]: entry }
      return entry
    } else {
      error.value = data.message || 'No content found'
      return null
    }
  } catch (err) {
    error.value = err.message
    return null
  } finally {
    isLoading.value = false
  }
}

function clearCache(reportId) {
  if (reportId) {
    const next = { ...cache.value }
    delete next[reportId]
    cache.value = next
  } else {
    cache.value = {}
  }
}

const currentMarkdown = computed(() => {
  if (!currentReportId.value) return null
  return cache.value[currentReportId.value] || null
})

export function useMarkdown() {
  return {
    cache,
    isLoading,
    error,
    currentReportId,
    currentMarkdown,
    fetchMarkdown,
    clearCache,
  }
}
